import { useMemo } from "react";
import { type IJointBillServiceProviderBillPlan } from "@services/jointBillServiceProviderBillPlans/types";
import { LT_MAX_PLANS } from "@utils/plans/constants";

/**
 * Gets the lowest price of MAX plan
 * @returns lowest price of MAX plan
 */
export const useMaxPlanPrice = (
  data: IJointBillServiceProviderBillPlan[] | undefined,
): number =>
  useMemo(() => {
    return (
      data
        ?.filter((plan) => LT_MAX_PLANS.has(plan.jointBillServicePlanId))
        .reduce(
          (acc, plan) => (acc === 0 || acc > plan.price ? plan.price : acc),
          0,
        ) ?? 0
    );
  }, [data]);
